// extracted by mini-css-extract-plugin
export default {"footer":"ConfigZone_footer__pwS6w","btn-save":"ConfigZone_btn-save__L3YuC","btn-cancle":"ConfigZone_btn-cancle__dvnv9","modal_loading":"ConfigZone_modal_loading__rGoK9"};